module.exports = __webpack_public_path__ + "assets/img/5e653fd5134bdc1ebae14486b02182db.svg";